import React, { useContext } from 'react';
import { RequestEntity } from 'types';
import UserInfoControlPanel from './components/UserInfoControlPanel/UserInfoControlPanel';
import Tabs from './components/Tabs/Tabs';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { IUserProfileContext, UserProfileContext } from '../../userProfileState/userProfileContext';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './UserInfo.module.scss';

const UserInfo: React.FC = () => {
	const { userForUserInfo } = useContext<IUserProfileContext>(UserProfileContext);

	const getDefaultAvatar = () => {
		const role = userForUserInfo?.roleName;
		return (
			<svg>
				<use xlinkHref={`${breadcrumbs}#userAvatar${role}`} />
			</svg>
		);
	};

	const defaultAvatar = getDefaultAvatar();

	return (
		<div className={style.container}>
			<div className={style.imageBlock}>
				{userForUserInfo?.filePath ? (
					<ImgUploaderByEntityId
						resource={RequestEntity.Users}
						entityID={userForUserInfo.id}
						photoSize="Medium"
						loaderSize="big"
					/>
				) : (
					<div className={style.imgBlank}>{defaultAvatar}</div>
				)}
			</div>
			<div className={style.infoBlock}>
				<UserInfoControlPanel />
				<Tabs />
			</div>
		</div>
	);
};

export default UserInfo;
